export default "__VITE_ASSET__B0_fC8gy__"